"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderingAppConfig = void 0;
const class_validator_1 = require("class-validator");
const AppConfig_1 = require("../../../../apis/spg/models/AppConfig");
/**
 * Model used for ordering app configuration
 */
class OrderingAppConfig extends AppConfig_1.AppConfig {
    constructor() {
        super(...arguments);
        this.preselection = {};
        this.deliveryId = "DELIVERY";
        this.serviceId = "SERVICE";
        this.pendingOrderStatusImage = "https://dph95f73vdxmz.cloudfront.net/uploads/National_Burrito_Day_Zambrero_607x406_v2.jpg";
        this.preparingOrderStatusImage = "https://dph95f73vdxmz.cloudfront.net/uploads/Product-people-franchise.jpg";
        this.readyOrderStatusImage = "https://dph95f73vdxmz.cloudfront.net/uploads/location_zambrero_mexican_food_Springwood_QLD_hero_Opt.jpg";
        this.deliveringOrderStatusImage = "https://dph95f73vdxmz.cloudfront.net/uploads/b881112873z1_20171204124311_000gv0t119t2-0-39ia86jz8a5zdg8ddp2_fct2279x1693_t1880.jpeg";
        this.completedOrderStatusImage = "https://dph95f73vdxmz.cloudfront.net/uploads/p4p-day-banner19.jpg";
        this.refundedOrderStatusImage = "https://dph95f73vdxmz.cloudfront.net/uploads/Step-3-Scan.jpg";
        this.brandLogoSmall = "https://dph95f73vdxmz.cloudfront.net/uploads/512.png";
        this.serialize = () => {
            return Object.assign(Object.assign({}, super.serialize()), { preselection: this.preselection, googleApiKey: this.googleApiKey, googleMapStyleId: this.googleMapStyleId, locationMaxRange: this.locationMaxRange, baseLocationImageUrl: this.baseLocationImageUrl, deliveryId: this.deliveryId, serviceId: this.serviceId, pendingOrderStatusImage: this.pendingOrderStatusImage, preparingOrderStatusImage: this.preparingOrderStatusImage, readyOrderStatusImage: this.readyOrderStatusImage, deliveringOrderStatusImage: this.deliveringOrderStatusImage, completedOrderStatusImage: this.completedOrderStatusImage, refundedOrderStatusImage: this.refundedOrderStatusImage, brandLogoSmall: this.brandLogoSmall });
        };
    }
    static unserialize(data) {
        const config = super.unserialize(data);
        config.preselection = data.preselection;
        config.googleApiKey = data.googleApiKey;
        config.googleMapStyleId = data.googleMapStyleId;
        config.locationMaxRange = parseFloat(data.locationMaxRange);
        config.baseLocationImageUrl = data.baseLocationImageUrl;
        config.deliveryId = data.deliveryId;
        config.serviceId = data.serviceId;
        config.pendingOrderStatusImage = data.pendingOrderStatusImage;
        config.preparingOrderStatusImage = data.preparingOrderStatusImage;
        config.readyOrderStatusImage = data.readyOrderStatusImage;
        config.deliveringOrderStatusImage = data.deliveringOrderStatusImage;
        config.completedOrderStatusImage = data.completedOrderStatusImage;
        config.refundedOrderStatusImage = data.refundedOrderStatusImage;
        config.brandLogoSmall = data.brandLogoSmall;
        return config;
    }
}
__decorate([
    (0, class_validator_1.IsOptional)()
], OrderingAppConfig.prototype, "preselection", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "googleApiKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], OrderingAppConfig.prototype, "googleMapStyleId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "baseLocationImageUrl", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "locationMaxRange", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "deliveryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "serviceId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "pendingOrderStatusImage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "preparingOrderStatusImage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "readyOrderStatusImage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "deliveringOrderStatusImage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "completedOrderStatusImage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "refundedOrderStatusImage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], OrderingAppConfig.prototype, "brandLogoSmall", void 0);
exports.OrderingAppConfig = OrderingAppConfig;
//# sourceMappingURL=OrderingAppConfig.js.map